import React from "react";
import { Box, Container, Grid, Link } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";


function Slider() {
  // Data for each card
  const cards = [
    {
      id: 1,
      title: "Journey to Vaishno Devi: A Divine Trek into the Heart of the Himalayas",
      description: "This one line captures the unwavering devotion of millions of pilgrims...",
      image: "/assets/blog/blog1.svg",
    },
    {
      id: 2,
      title: "Gangotri Temple: In the Lap of the Ganges and the Himalayas",
      description: "Explore one of the most famous Hindu temples dedicated to Lord Shiva...",
      image: "/assets/blog/blog2.svg",
    },
    {
      id: 3,
      title: "Dwarkadhish Temple: The Eternal Kingdom of Lord Krishna",
      description: "A tale of spiritual connection and sacred bridges across the sea...",
      image: "/assets/blog/blog3.svg",
    },
    {
      id: 4,
      title: "Journey to Vaishno Devi: A Divine Trek into the Heart of the Himalayas",
      description: "Witness the grandeur of devotion and wealth at Tirumala hills...",
      image: "/assets/blog/blog1.svg",
    },
    {
      id: 5,
      title: "Gangotri Temple: In the Lap of the Ganges and the Himalayas",
      description: "Tucked in the Himalayas, this temple offers divine peace and scenic beauty.",
      image: "/assets/blog/blog2.svg",
    },
    {
      id: 6,
      title: "Dwarkadhish Temple: The Eternal Kingdom of Lord Krishna",
      description: "A journey through the chariot festival and coastal divinity...",
      image: "/assets/blog/blog3.svg",
    },
  ];

  return (
    <section>
    <Box className="blogSliderBox">
      <Container maxWidth="md">
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Box className="templeInnerHeading" textAlign="center">
              <h2>Explore Latest Blogs</h2>
            </Box>
          </Grid>

          <Grid item xs={12}>
          <Box>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={3}
              navigation
            //   pagination={{ clickable: true }}
            autoplay={{
    delay: 30000,  
    disableOnInteraction: false,
  }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1200: { slidesPerView: 3 }, // Optional: 4 cards on large screens
              }}
            >
              {cards.map((card) => (
                <SwiperSlide key={card.id}>
                <Box className="blogSlider">
                  <Box className="blogCard">
                    <Box className="blogCardImage">
                      <img src={card.image} alt={card.title} />
                    </Box>
                    <Box className="blogCardDetails">
                      <div className="blogHeading">{card.title}</div>
                      <p>{card.description}</p>
                      <Link href="coming-soon">Read full article</Link>
                    </Box>
                  </Box>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      
    </Box>
    </section>
  );
}

export default Slider;
